var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "label",
    {
      key: _vm.item.value,
      class: _vm.question.getItemClassByText(_vm.item.itemValue, _vm.item.text),
      on: {
        mousedown: function ($event) {
          return _vm.question.onMouseDown()
        },
      },
    },
    [
      _c("input", {
        staticClass: "sv-visuallyhidden",
        attrs: {
          type: "radio",
          name: _vm.question.questionName,
          id: _vm.question.getInputId(_vm.index),
          disabled: _vm.question.isDisabledAttr,
          readonly: _vm.question.isReadOnlyAttr,
          "aria-required": _vm.question.ariaRequired,
          "aria-label": _vm.question.ariaLabel,
          "aria-invalid": _vm.question.ariaInvalid,
          "aria-errormessage": _vm.question.ariaErrormessage,
        },
        domProps: { value: _vm.item.value },
        on: {
          click: function (e) {
            return _vm.question.setValueFromClick(e.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "span",
        {
          class: _vm.question.cssClasses.itemText,
          attrs: { "data-text": _vm.item.text },
        },
        [_c("survey-string", { attrs: { locString: _vm.item.locText } })],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }